module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "language-select"
  }, [_c('button', {
    staticClass: "flag flag-ru",
    on: {
      "click": function($event) {
        _vm.chooseLanguage('ru')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "flag flag-us",
    on: {
      "click": function($event) {
        _vm.chooseLanguage('en')
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e4cccca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/i18n/Language.vue
// module id = 523
// module chunks = 0